import { EntityName } from 'src/types/EntityName';

export const MEAL_CREDIT_ENTITY_NAME: EntityName = {
  singular: 'meal credit',
  plural: 'meal credits',
};
